import { BaseResponse, IBaseResponse } from '../../models/comm-http/responses/BaseResponse';

import { Component, OnInit } from '@angular/core';

import { BillingRecurringTypes, UpgradableProductsResponseArray, UpgradableProductsResponse } from 'app/models/ss-api/responses/upgradable.products.response';
import { SelectItem } from 'primeng/api';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { UpgradeProductRequest } from 'app/models/ss-api/requests/upgrade.product.request';
import { ssApiService } from 'app/services/ss-api.service';
import { DashboardLicenseResponse } from '../../models/ss-api/responses/dashboard.license.response';
import { GlobalServices } from 'app/services/global.service';

import { UpgradeSimulationResponse } from '../../models/ss-api/responses/upgrade.simulation.response';
import { CreditCardResponseArray } from 'app/models/ss-api/responses/credit.card.response';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

export interface IUpgradeProductDialogModel {
  title: string;
  subTitle: string;
  message: string;
  upgradeProducts: UpgradableProductsResponseArray;
  CreditCards: SelectItem[];
  SelectedCreditCard: number;
  LicenseKey: string;

  LicenseObject: DashboardLicenseResponse;

  CurrentProductBillingCycle: BillingRecurringTypes;

}

interface productOptionItem {
  name: string;
  productID: number;
  billingCycle: BillingRecurringTypes;
}

@Component({
  selector: 'upgrade-product-dialog',
  styleUrls: ['./upgrade-product-dialog.component.scss'],
  templateUrl: './upgrade-product-dialog.component.html'
})
export class UpgradeProductDialogComponent implements IUpgradeProductDialogModel, OnInit {

  IsBusy: boolean = true;

  confirmTitle: string = 'Upgrade Membership';

  successTitle: string = 'Membership Upgraded!';
  successMessage: string = 'Your purchase was successfull. Please restart your software so that it can update to Vip3D';

  errorTitle: string = 'Error';
  errorMessage: string = 'We were not able to process this request. Try again later or use a different credit card.';

  cancelledTitle: string = 'Cancelled';
  cancelledMessage: string = 'You cancelled this upgrade.';



  title: string;
  subTitle: string;
  message: string;
  upgradeProducts: UpgradableProductsResponseArray;
  CreditCards: SelectItem[];
  SelectedCreditCard: number;

  SelectedProduct: UpgradableProductsResponse = new UpgradableProductsResponse();
  SelectedProductLock: boolean = false;

  ProductOptions: productOptionItem[] = [];
  SelectedProductOption: number;

  PurchaseDisabled: boolean = false;
  Initals: string = 'AP'; // Account Panel
  LicenseKey: string = '';
  LicenseObject: DashboardLicenseResponse;


  // CURRENT PRODUCT VARIABLES
  CurrentProductBillingCycle: BillingRecurringTypes;

  CurrentProductName: string = 'Vip3D';

  TodaysDate: Date = new Date();
  RenewDate: Date = new Date();

  PriceSimulationResponse: UpgradeSimulationResponse = new UpgradeSimulationResponse;
  CreditAmount: number = 0;
  DebitAmount: number = 0;
  PriceDue: any = 0;
  PriceDueWithTax: any = 0;
  State: string = "";
  TaxRateDisplay: string = "";

  TaxEnabled: boolean = false;

  Credit: number = 0;
  TotalDueUpgradeTaxAmount: number = 0;

  result: any;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private api: ssApiService,
    private gb: GlobalServices
  ) {
  }

  async ngOnInit() {
    this.title = this.config.data.title;
    this.subTitle = this.config.data.subTitle;
    this.message = this.config.data.message;
    this.upgradeProducts = this.config.data.upgradeProducts;
    this.CreditCards = this.config.data.CreditCards;
    this.SelectedCreditCard = this.config.data.SelectedCreditCard;
    this.LicenseKey = this.config.data.LicenseKey;
    this.CurrentProductBillingCycle = this.config.data.CurrentProductBillingCycle;
    this.LicenseObject = this.config.data.LicenseObject;

    this.setUpProductOptions();

    console.log("Upgrade Products Options", this.upgradeProducts);

    if (this.SelectedProduct == undefined) {

    }

    this.GetCredit();

    let request = new UpgradeProductRequest();
    request.CreditCardID = 0;
    request.Initials = 'PS'; // Price Simulation
    request.LicenseKey = this.LicenseKey;
    request.NewBillingCycle = this.SelectedProduct.BillingCycle;
    request.NewProductID = this.SelectedProduct.ProductID;
    request.SimulateOnly = true;
    request.AdminID = this.gb.AdminID;

    await this.simulateUpgradePrice(request).then(
      (response) => {
        console.log("SimUpdResp", response.Data);
        this.PriceDue = response.Data.TotalDueUpgrade;
        this.PriceDueWithTax = response.Data.TotalDueUpgradeWithTax;
        this.PriceSimulationResponse = response.Data;
        this.TaxEnabled = response.Data.TaxEnabled;
        this.TotalDueUpgradeTaxAmount = response.Data.TotalDueUpgradeTaxAmount;
        this.TaxRateDisplay = response.Data.TaxRateDisplay;
        this.State = response.Data.State;
      }
    );

    if (this.CreditCards) {
      this.SelectedCreditCard = this.CreditCards[0].value;
    }
    this.IsBusy = false;

  }

  close() {
    this.ref.close();
  }


  setUpProductOptions() {
    this.upgradeProducts.forEach(x => {
      let newName: string = x.Name + ' ' + this.getBillingCycleName(x.BillingCycle);

      if (x.HasYard)
        newName += ' + YARD';

      this.ProductOptions.push({ name: newName, productID: x.ProductID, billingCycle: x.BillingCycle });
    });

    this.SelectedProductOption = this.ProductOptions[0].productID;

    this.setSelectedProduct(this.ProductOptions[0]);
  }

  getBillingCycleName(billingCycle: BillingRecurringTypes): string {
    if (billingCycle == BillingRecurringTypes.Monthly)
      return 'Monthly';
    else
      return 'Yearly';
  }

  setSelectedProduct(e: productOptionItem) {
    this.upgradeProducts.forEach(x => {
      if (x.ProductID == e.productID && x.BillingCycle == e.billingCycle) {
        this.SelectedProduct = x;
      }

    });


    this.RenewDate = new Date(this.LicenseObject.NextBillingDate);
    if (this.SelectedProduct.BillingCycle == BillingRecurringTypes.Yearly) {
      this.RenewDate.setFullYear(this.RenewDate.getFullYear() + 1);
    }

  }

  async ProductChanged(e) {

    this.IsBusy = true;

    let newProductOption: productOptionItem = {
      name: e.value.name,
      productID: e.value.productID,
      billingCycle: e.value.billingCycle
    };

    this.setSelectedProduct(newProductOption);

    let request = new UpgradeProductRequest();
    request.CreditCardID = 0;
    request.Initials = 'PS'; // Price Simulation
    request.LicenseKey = this.LicenseKey;
    request.NewBillingCycle = this.SelectedProduct.BillingCycle;
    request.NewProductID = this.SelectedProduct.ProductID;
    request.SimulateOnly = true;
    request.AdminID = this.gb.AdminID;

    await this.simulateUpgradePrice(request).then(
      (response) => {
        this.PriceDue = response.Data.TotalDueUpgrade;
        this.PriceSimulationResponse = response.Data;
        this.PriceDueWithTax = response.Data.TotalDueUpgradeWithTax;
        this.TaxEnabled = response.Data.TaxEnabled;
        this.TotalDueUpgradeTaxAmount = response.Data.TotalDueUpgradeTaxAmount;
        this.TaxRateDisplay = response.Data.TaxRateDisplay;
        this.State = response.Data.State;
      }
    );

    this.IsBusy = false;

  }


  simulateUpgradePrice(request: UpgradeProductRequest): Promise<IBaseResponse<UpgradeSimulationResponse>> {
    /*
    let request = new UpgradeProductRequest();
    request.CreditCardID = 0;
    request.Initials = "PS"; //Price Simulation
    request.LicenseKey = this.LicenseKey;
    request.NewBillingCycle = this.SelectedProduct.BillingCycle;
    request.NewProductID = this.SelectedProduct.ProductID;
    request.SimulateOnly = true;
    */

    return this.api.ProductsUpgradeSimulation(request).toPromise();

  }

  ProductSelectionChanged(product: UpgradableProductsResponse) {
    this.SelectedProduct = product;
    this.SelectedProductLock = false;
    this.CheckPurchaseDisabled();


  }


  BillingTypeToString(type: BillingRecurringTypes) {
    return BillingRecurringTypes[type];
  }

  BillingTypeToPerString(type: BillingRecurringTypes) {
    if (type == BillingRecurringTypes.Monthly)
      return 'per Month';
    else
      return 'per Year';
  }

  CreditCardChanged() {

  }

  InitialsChanged(data: string) {
    this.CheckPurchaseDisabled();
  }

  CheckPurchaseDisabled() {
    // if (this.Initals != "" && !this.SelectedProductLock)
    if (!this.SelectedProductLock)
      this.PurchaseDisabled = false;
    else
      this.PurchaseDisabled = true;
  }

  SelectedBillingCycleToString(): string {

    switch (this.SelectedProduct.BillingCycle) {

      case BillingRecurringTypes.Monthly:
        return 'month';

      case BillingRecurringTypes.Yearly:
        return 'year';

      default:
        return 'unimplemented';
    }

  }

  private UpgradeProduct(): Promise<any> {

    if (this.SelectedCreditCard == undefined)
      // we didn't change the credit card selection
      this.SelectedCreditCard = this.CreditCards[0].value;

    let request = new UpgradeProductRequest();
    request.CreditCardID = this.SelectedCreditCard;
    request.Initials = this.Initals;
    request.LicenseKey = this.LicenseKey;
    request.NewBillingCycle = this.SelectedProduct.BillingCycle;
    request.NewProductID = this.SelectedProduct.ProductID;
    request.SimulateOnly = false; // for debug
    request.AdminID = this.gb.AdminID;

    return this.api.ProductsUpgrade(request)
      .toPromise()
      .then(response => {
        this.result = response.Result;
        return response;
      });
  }

  ProcessOrder(): Promise<any> {
    // confirm
    return Swal.fire({
      title: this.confirmTitle,
      text: 'You are about to upgrade a membership to ' + this.SelectedProduct.Name + '. Your credit card will be billed.',
      icon: 'warning',
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: 'Yes!',
      cancelButtonText: 'Cancel',
      allowOutsideClick: false,
      showLoaderOnConfirm: true,
      preConfirm: () => {
        // try to order
        return this.UpgradeProduct();
      }
    });

  }

  async confirm() {
    this.result = true;

    await this.ProcessOrder().then(
      (response: any) => {

        // init dialog vars
        let cType = 'success';
        let cTitle = this.successTitle;
        let cMessage = 'Your purchase was successfull. Please restart your software so that it can update to ' + this.SelectedProduct.Name + '.';

        if (response.isDismissed) {
          // show cancelled
          Swal.fire({
            title: this.cancelledTitle,
            text: this.cancelledMessage,
            icon: 'error',
            showCancelButton: false,
            showConfirmButton: false,
            timer: 1000
          })
            .then(() => { }, () => { }); // keep this line to prevent promise error;
        } else if (response.value && response.value.Result) {
          // show result
          Swal.fire(
            {

              title: cTitle,
              text: cMessage,
              icon: cType as SweetAlertIcon,
              showCancelButton: false,
              showConfirmButton: false,
              timer: 2000
            })
            .then(() => { }, () => { }); // keep this line to prevent promise error;
        }
        else {
          // not ok

          Swal.fire(
            {

              title: this.errorTitle,
              text: this.errorMessage,
              icon: 'error',
              showCancelButton: false,
              showConfirmButton: true,
              confirmButtonText: 'OK',
            })
            .then(() => { }, () => { }); // keep this line to prevent promise error;
        }
      },
      (dismiss) => {
        if (dismiss === 'cancel') {
          this.result = false;

          if (!confirm)
            return;

          // show cancelled
          Swal.fire({
            title: this.cancelledTitle,
            text: this.cancelledMessage,
            icon: 'error',
            showCancelButton: false,
            showConfirmButton: false,
            timer: 1000
          })
            .then(() => { }, () => { }); // keep this line to prevent promise error;
        }
      });

    this.close();
  }




  cancel() {
    // we set dialog result as true on click on confirm button,
    // then we can get dialog result from caller code
    this.result = false;
    this.close();
  }


  showAddCreditCard: boolean = false;

  cardAdded({ cards, newCardId }: { cards: CreditCardResponseArray, newCardId: number }) {
    this.showAddCreditCard = false;
    this.updateCreditCardOptions(cards);
    this.SelectedCreditCard = newCardId;
    this.CheckPurchaseDisabled();
  }

  addCardCanceled() {
    this.showAddCreditCard = false;
  }

  updateCreditCardOptions(newCards: CreditCardResponseArray) {
    this.CreditCards = [];
    newCards.forEach(card => {
      this.CreditCards.push(
        {
          label: 'Name: ' + card.FirstName + ' ' + card.LastName +
            ' - Last four: ' + card.LastFour +
            ' - exp. Date: ' + card.ExpMonth + '/' + card.ExpYear,
          value: card.ID
        });
    });
  }

  GetCredit() {
    this.IsBusy = true;

    let subscription = this.api.MemberCredit().subscribe(response => {
      subscription.unsubscribe();
      this.IsBusy = false;
      this.Credit = response.Data;
    }, error => {
      subscription.unsubscribe();
      this.IsBusy = false;
    });

  }

  GetPriceDue(): number {
    let totalPriceDue: number = 0;
    totalPriceDue += this.PriceDueWithTax;
    totalPriceDue -= this.Credit;
    if (totalPriceDue < 0 || Number.isNaN(totalPriceDue))
      totalPriceDue = 0;

    return totalPriceDue;
  }

  CreditUsed(): number {
    if (this.Credit > this.PriceDue)
      return this.PriceDueWithTax;
    else
      return this.Credit;
  }



  ProductNameAdditions(): string {
    let additions: string = '';

    if (this.SelectedProduct.HasYard)
      additions += ' + YARD';

    return additions;
  }

}
